import { Dot } from 'components';
import styled from '@emotion/styled';
import { SpeakingSlotType } from 'api/planning';

type Props = {
  speakingSlotTypes: SpeakingSlotType[];
};

export const SpeakingSlotTypesIndicator = ({ speakingSlotTypes }: Props) => {
  return (
    <S.Container>
      <Dot
        color={speakingSlotTypes.includes(SpeakingSlotType.IPC) ? '#415561' : '#efefef'}
        size="5px"
      />
      <Dot
        color={speakingSlotTypes.includes(SpeakingSlotType.IPA) ? '#19b6ad' : '#efefef'}
        size="5px"
      />
      <Dot
        color={speakingSlotTypes.includes(SpeakingSlotType.RSS) ? '#de3494' : '#efefef'}
        size="5px"
      />
      <Dot
        color={speakingSlotTypes.includes(SpeakingSlotType.SWA) ? '#9f07d2' : '#efefef'}
        size="5px"
      />
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    display: grid;
    grid-template-columns: 12px 12px;
    grid-template-rows: 12px 12px;
  `,
};
